export default __webpack_public_path__ + "static/media/Gamestar_JD_TechnicalProductLead.507b7978.pdf";